import organizationActionConstants from '../constants/organizationActionConstants';

const initialState = {
  userOrganizations: [],
  userOrganizationsFetched: false,
  currentOrganization: null,
  previousCurrentOrg: null,
  currentOrganizationLoading: false,
  organizationIdentifierLoading: false,
  dropdownValues: {},
  organizationCreationLoading: false,
};

const organizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case organizationActionConstants.GET_ORGANIZATIONS:
      return {
        ...state,
        userOrganizations: [],
        userOrganizationsFetched: false,
      };
    case organizationActionConstants.GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        userOrganizations: action.payload,
        userOrganizationsFetched: true,
      };
    case organizationActionConstants.SET_ORGANIZATION_FETCHED:
      return {
        ...state,
        userOrganizationsFetched: false,
      };
    case organizationActionConstants.GET_ORGANIZATIONS_ERROR:
      return {
        ...state,
        userOrganizationsFetched: true,
      };
    case organizationActionConstants.SET_CURRENT_ORGANIZATION_LOADING:
      return {
        ...state,
        currentOrganizationLoading: true,
      };
    case organizationActionConstants.GET_DROPDOWN_VALUES_SUCCESS:
      return {
        ...state,
        dropdownValues: action.payload,
      };
    case organizationActionConstants.SET_CURRENT_ORGANIZATION:
      return {
        ...state,
        currentOrganizationLoading: false,

        previousCurrentOrg: state.currentOrganization,
        currentOrganization: action.payload,
      };
    case organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER:
      return {
        ...state,
        organizationIdentifierLoading: true,
      };
    case organizationActionConstants.REMOVE_CURRENT_ORGANIZATION:
      return {
        ...state,
        currentOrganization: null,
      };
    case organizationActionConstants.GET_ORGANIZATION_BY_IDENTIFIER_SUCCESS:
      return {
        ...state,
        currentOrganizationLoading: false,
        organizationIdentifierLoading: false,
        userOrganizationsFetched: true,
        previousCurrentOrg: state.currentOrganization,
        currentOrganization: action.payload,
      };
    case organizationActionConstants.SAVE_ORGANIZATION_DETAILS:
      return {
        ...state,
        organizationCreationLoading: true,
      };
    case organizationActionConstants.SAVE_ORGANIZATION_DETAILS_ERROR:
      return {
        ...state,
        organizationCreationLoading: false,
      };
    default:
      return state;
  }
};

export default organizationsReducer;
